import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
function HelpOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.24 9.55a2.414 2.414 0 012.728-.744c.51.191.806.725.701 1.25a1.521 1.521 0 01-.416.777l-.9.9A4.621 4.621 0 0011 15h2c0-.695.276-1.362.768-1.854l.9-.9a3.522 3.522 0 00.962-1.798 3.11 3.11 0 00-1.96-3.515A4.414 4.414 0 008.68 8.3l-.46.575 1.56 1.25.46-.575zM13 18v-2h-2v2h2z",
    fill: "#F0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z",
    fill: "#F0C"
  }));
}
export default HelpOutline;